import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';
import { usePageContent } from '../../context/ContentContext';

const Footer = () => {
  const { g } = usePageContent('global');

  return (
      <footer className="bg-background-cool-blue py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Sustainable Yarns & Practices */}
            <div className="text-center">
              <h4 className="font-poppins font-semibold text-h3 mb-4 text-primary-dark-red">
                {g('footer.col1Title')}
              </h4>
              <a
                href={g('footer.col1LinkUrl')}
                target="_blank"
                rel="noopener noreferrer"
                className="font-poppins font-normal text-sub text-gray-600 hover:text-primary-red transition-colors"
              >
                {g('footer.col1LinkText')}
              </a>
            </div>

            {/* Production */}
            <div className="text-center">
              <h4 className="font-poppins font-semibold text-h3 mb-4 text-primary-dark-red">
                {g('footer.col2Title')}
              </h4>
              <p className="font-poppins font-normal text-sub text-gray-600">
                {g('footer.col2Text')}
              </p>
            </div>

            {/* Ethics */}
            <div className="text-center">
              <h4 className="font-poppins font-semibold text-h3 mb-4 text-primary-dark-red">
                {g('footer.col3Title')}
              </h4>
              <div className="space-y-2">
                <Link
                  to="/modern-slavery"
                  className="font-poppins font-normal text-sub text-gray-600 hover:text-primary-red transition-colors block"
                >
                  {g('footer.col3Link1')}
                </Link>
                <Link
                  to="/environmental-policy"
                  className="font-poppins font-normal text-sub text-gray-600 hover:text-primary-red transition-colors block"
                >
                  {g('footer.col3Link2')}
                </Link>
                {/* Separate app at /careers, so a plain anchor and a full page
                    load. Also the link that lets Google find the careers site. */}
                <a
                  href="/careers"
                  className="font-poppins font-normal text-sub text-gray-600 hover:text-primary-red transition-colors block"
                >
                  Careers &amp; internships
                </a>
              </div>
            </div>
          </div>

          {/* Social Media - Removed Twitter */}
          <div className="flex justify-center space-x-8 mb-8">
            <a
                href={g('footer.facebookUrl')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-dark-red hover:text-primary-red transition-colors"
            >
              <Facebook className="h-8 w-8" />
            </a>
            <a
                href={g('footer.instagramUrl')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-dark-red hover:text-primary-red transition-colors"
            >
              <Instagram className="h-8 w-8" />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center font-poppins font-normal text-sub text-gray-600">
            <p>&copy; {new Date().getFullYear()} {g('footer.copyrightName')}</p>
            <p className="mt-2 text-xs text-gray-400">{g('footer.credit')}</p>
          </div>
        </div>
      </footer>
  );
};

export default Footer;
